import React from 'react';
import ReactDOM from 'react-dom';
import JackRabbit from './jackrabbit.js';


Storage.prototype.setObject = function(key, value) {
  this.setItem(key, JSON.stringify(value));
}

Storage.prototype.getObject = function(key) {
  var value = this.getItem(key);
  return value && JSON.parse(value);
}

document.addEventListener("DOMContentLoaded", function() {

  if (document.getElementById('jackrabbit-widget') && !document.getElementById('event-dashboard')) {
    ReactDOM.render(
      <JackRabbit></JackRabbit>,
      document.getElementById('jackrabbit-widget')
    );
  }

});
